/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../shared/qrequest";
import AILoader from "./AILoader";
import Alert from "./Alert";
import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import Icon from "./Icon";
import L from "./Lang";
import UploadPad from "./UploadPad";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class DocumentAnalyzeUpload extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
        if (this.interval)
            clearInterval(this.interval);
    }

    uploadEnd = async (item) => {
        const info = { ...item };
        info.base64Encoded = null;
        this.setState({ processing: true, complete: false, error: false, errorMessage: null });
        try {
            const j = await qreq.postAsync('/api/document/analyze', info);
            if (j.errorCode === 0) {
                this.success('Analysis process begun...');
                this.setState({ item: j.item });
                this.interval = setInterval(this.status, 5000);
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    status = async () => {
        try {
            const j = await qreq.getAsync('/api/document/analyze/status?tid=' + this.state.item.tid);
            if (j.item) {
                this.setState({ item: j.item });
                if (j.item.analyzeStatus === 'Complete') {
                    this.setState({ processing: false, complete: true, info: { ...j.item.attachOrder.patient }, order: { ...j.item.attachOrder }, analyzeText: j.item.analyzeText });
                    clearInterval(this.interval);
                }
                else if (j.item.analyzeStatus === 'Error') {
                    this.setState({ processing: false, error: true, errorMessage: j.item.errorMessage });
                    clearInterval(this.interval);
                }
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    createNew = async () => {
        const info = { patient: { ...this.state.info } };
        if (this.state.info.insurances && this.state.info.insurances.length)
            info.insurances = [...this.state.info.insurances];
        try {
            const j = await qreq.postAsync('/api/lead/save', info);
            if (j.errorCode === 0) {
                this.success('Record saved!');
                this.props.navigate('/lead/edit/' + j.item.id);
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    attach = async () => {
        const info = { ...this.state.item, orderID: this.state.order.id, order: { patient: { ...this.state.info } } };
        if (this.state.info.insurances && this.state.info.insurances.length)
            info.order.insurances = [...this.state.info.insurances];
        try {
            const j = await qreq.postAsync('/api/document/attach', info);
            if (j.errorCode === 0) {
                this.success('Attached!');
                if (j.item.isLead)
                    this.props.navigate('/lead/edit/' + j.item.id);
                else
                    this.props.navigate('/order/view/' + j.item.id);
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    render() {
        return <div className="container-fluid">
            <h1><L>Document Analyzer</L></h1>
            {!this.state.processing && <p className="lead"><L>Upload a document to analyze.</L></p>}
            {!this.state.processing && <UploadPad onUploadEnd={this.uploadEnd} />}
            {this.state.processing && <AILoader />}
            {this.state.complete && <>
                <Card title="Patient">
                    {!this.state.order?.id ? <>
                        <FormInput model={this.state.info} name="firstName" label="First Name" />
                        <FormInput model={this.state.info} name="lastName" label="Last Name" />
                        <FormInput model={this.state.info} name="birthDate" label="Birth Date" />
                        <button type="button" className="btn btn-success btn-lg" onClick={this.createNew}>
                            <Icon icon="faSave" /> <L>Create New Record</L>
                        </button>
                    </> : <>
                        <div className="mb-3">
                            <h5>Patient</h5>
                            <div>Patient Name: <strong>{this.state.info?.fullName}</strong></div>
                            <div>Birth Date: <strong>{this.state.info?.birthDate}</strong></div>
                        </div>
                        {this.state.order?.provider && <div className="mb-3">
                            <h5>Provider</h5>
                            <div>Provider Name: <strong>{this.state.order?.provider?.firstName} {this.state.order?.provider?.lastName}</strong></div>
                            <div>NPI: <strong>{this.state.order?.provider?.npi}</strong></div>
                        </div>}
                        {this.state.order?.diagCodes && <div className="mb-3">
                            <h5>Diag Codes</h5>
                            <ul className="list-group">
                                {this.state.order.diagCodes.map((i, idx) => <li key={idx} className="list-group-item"><strong>{i.displayCode}</strong> {i.description}</li>)}
                            </ul>
                        </div>}
                        {this.state.order?.status === 'LYMPHEDEMA' && <div className="mb-3">
                            <h5>This patient has Lymphedema</h5>
                            <p>{this.state.order?.notes}</p>
                        </div>}
                        <button type="button" className="btn btn-primary btn-lg" onClick={this.attach}>
                            <Icon icon="faFilePdf" /> <L>Attach to Patient</L>
                        </button>
                    </>}
                </Card>
                <Card title="Text Analyzed">
                    <pre>{this.state.analyzeText}</pre>
                </Card>
            </>}
            {this.state.error && <Alert title="Error">{this.state.errorMessage}</Alert>}
        </div>;
    }
}

export default withParamsAndNavigate(DocumentAnalyzeUpload);